import React from 'react';
import useLivePrices from '../hooks/useLivePrices';

const fmt = (n) =>
  n >= 1
    ? `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
    : `$${n.toFixed(4)}`;

const LiveTicker = () => {
  const { prices, loading } = useLivePrices();

  const items = loading
    ? [{ sym: 'Loading live prices...', price: '', chg: '', up: true }]
    : [
        ...Object.values(prices).map((c) => ({
          sym: c.symbol,
          price: fmt(c.price),
          chg: `${c.changePct >= 0 ? '+' : ''}${c.changePct.toFixed(2)}%`,
          up: c.changePct >= 0,
        })),
        { sym: 'NIFTY 50', price: '22,450', chg: '+0.6%', up: true },
        { sym: 'SENSEX', price: '73,820', chg: '+0.4%', up: true },
      ];

  const doubled = [...items, ...items];

  return (
    <div className="ticker-wrapper">
      {!loading && <span className="ticker-live-badge">● LIVE</span>}
      <div className="ticker-inner">
        {doubled.map((item, i) => (
          <div className="ticker-item" key={i}>
            <span className="ticker-sym">{item.sym}</span>
            <span className="ticker-price">{item.price}</span>
            <span className={`ticker-chg ${item.up ? 'up' : 'down'}`}>{item.chg}</span>
            <span className="ticker-sep">|</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveTicker;